// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TimeEntityConfig__container___1fSmD{width:70%;margin:0 auto;margin-bottom:60px}.TimeEntityConfig__title___j2oDF{font-size:20px;font-weight:600}.TimeEntityConfig__subtitle___3b2Lh{font-size:18px;font-weight:400}.TimeEntityConfig__group___zDpHc{padding:10px 0px}.TimeEntityConfig__head___1YOHY{font-size:16px;border-bottom:1px solid #e9e9e9;font-weight:500;margin-bottom:10px}.TimeEntityConfig__row___2lqR3{display:flex}.TimeEntityConfig__key___tdqHm{flex:1}.TimeEntityConfig__value___14AFt{flex:1}\n", ""]);
// Exports
exports.locals = {
	"container": "TimeEntityConfig__container___1fSmD",
	"title": "TimeEntityConfig__title___j2oDF",
	"subtitle": "TimeEntityConfig__subtitle___3b2Lh",
	"group": "TimeEntityConfig__group___zDpHc",
	"head": "TimeEntityConfig__head___1YOHY",
	"row": "TimeEntityConfig__row___2lqR3",
	"key": "TimeEntityConfig__key___tdqHm",
	"value": "TimeEntityConfig__value___14AFt"
};
module.exports = exports;
